import loadable from "loadable-components";

const BrandsPageRoute = loadable(() =>
  import(/* webpackPreload: true, webpackChunkName: "b" */ "../BrandsPage")
);

export default BrandsPageRoute;
